import { useState, useCallback, useRef } from "react";

const RESET_FILTER = {
  deal_type: [],
  randType: [],
  useArea: [],
  floorType: [],
  availableDate: [],
  roomCnt: [],
  bathroomCnt: [],
  direction: [],
  approvalYear: null,
  minPrice: null,
  maxPrice: null,
  minMonthly: null,
  maxMonthly: null,
  minDeposit: null,
  maxDeposit: null,
  // 면적은 항상 m² 단위로 저장
  minArea: null,
  maxArea: null,
  areaUnit: "pyeong",
  selectedCategory: null,
  ownerVerifiedOnly: "",
};

/**
 * 매물탐색 필터 상태 관리 hook
 *
 * @returns {{
 *   payload: Object,
 *   payloadRef: React.MutableRefObject,
 *   handlePayload: (key: string, value: any) => void,
 *   handleResetPayload: () => void,
 *   setPayload: Function,
 *   RESET_FILTER: Object,
 * }}
 */
export default function useExploreFilter() {
  const [payload, setPayload] = useState({ ...RESET_FILTER });
  const payloadRef = useRef(payload);

  // payloadRef를 항상 최신으로 유지
  payloadRef.current = payload;

  const handlePayload = useCallback((key, value) => {
    setPayload((prev) => {
      let processedValue = value;
      // randType: 배열 → 평탄화된 쉼표 구분 문자열 (백엔드 split(",") 호환)
      // subOption value에 "10,11" 같은 복합값이 포함될 수 있으므로 개별 숫자로 전개
      // 빈 배열은 "" 대신 []를 유지해야 FilterChipBar의 hasActiveFilter가 비활성으로 판정함
      if (key === "randType" && Array.isArray(value)) {
        const parts = value
          .flatMap((v) => String(v).split(",").map((s) => s.trim()))
          .filter(Boolean);
        processedValue = parts.length > 0 ? parts.join(",") : [];
      }

      if (prev[key] !== processedValue) {
        return { ...prev, [key]: processedValue };
      }
      return prev;
    });
  }, []);

  const handleResetPayload = useCallback(() => {
    setPayload({ ...RESET_FILTER });
  }, []);

  return {
    payload,
    payloadRef,
    handlePayload,
    handleResetPayload,
    setPayload,
    RESET_FILTER,
  };
}
